module.exports = __webpack_public_path__ + "img/icon-advanced-default.626484b5.svg";